import EventList, {IEventData} from "../EventList/EventList";
import {useEffect, useRef, useState} from "react";
import axios from "axios";
import {makeStyles} from "@material-ui/core/styles";
import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import useWindowDimensions from "../util/useWindowDimensions";
import {Button, ButtonBase, ButtonGroup, Grid, Paper} from "@material-ui/core";
import AppsIcon from '@material-ui/icons/Apps';
import ListIcon from '@material-ui/icons/List';
import {ToggleButton, ToggleButtonGroup} from "@material-ui/lab";
import ReactDOM from "react-dom";

export interface IEventListTabsProps {
  events: string[],
  closingDate: string
}




function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexDirection: 'column',
    width: '100%',
  },
  toggleGroup: {
    marginBottom: '25px',
  },
  gridItem: {
    textAlign: 'center',

  },
  gridItemTitle: {
    fontSize: '1.5rem',
    lineHeight: '1.2',
    margin: '0.3em 0 0 0',
  },
  placeButton: {
    width: '100%',
    flexDirection: 'column',
    padding: '15px',
  },
  tabsroot: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      width: '100%',
    }
  },
  tabs: {
    [theme.breakpoints.up('md')]: {
      borderRight: `1px solid ${theme.palette.divider}`,
      width: '200px',
      minWidth: '200px',
    },
  },
  tabRoot: {
    paddingTop: '20px',
    paddingBottom: '20px',
    [theme.breakpoints.up('md')]: {
      paddingTop: '0',
      paddingBottom: '0',
      paddingLeft: '20px',
      paddingRight: '20px',
    },
  }

}));

const EventListTabs = (props: IEventListTabsProps) => {
  const [eventDataList, setEventDataList] = useState<IEventData[]>([]);
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const {height, width} = useWindowDimensions();
  const [view, setView] = React.useState('grid');
  const rootRef = useRef<HTMLDivElement>(null);

  const handleViewChange = (event: any, newAlignment: React.SetStateAction<string>) => {
    if (newAlignment !== null) {
      setView(newAlignment);
    }
  };

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  const scrollToRootRef  = () => {
    let node = ReactDOM.findDOMNode(rootRef.current) as Element;
    node.scrollIntoView({block: 'start', behavior: 'smooth'});
  }

  const setCurrentPlace = (index: number) => {
    setValue(index);
    setView('list');
    scrollToRootRef();
  };

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    var getUrl = window.location;
    var baseURL = getUrl.protocol + "//" + getUrl.host;
    if (baseURL == 'http://localhost:3000') {
      baseURL = 'https://buxliest.local.computer/';
    }
    axios.get(baseURL + "/" + "/bux-api/bux-event/event-data-all/" + props.events.join('-') + "?_format=json", {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((result) => {
        setEventDataList(result.data);
      })
      .catch(error => {
        if (error.response) {
          console.log(error.responderEnd);
        }
      });
  }

  const orientation = width > 960 ? "vertical" : "horizontal";
  return (
    <div className={classes.root}>
      <div ref={rootRef}></div>
      <ToggleButtonGroup
        value={view}
        exclusive
        onChange={handleViewChange}
        aria-label="text alignment"
        className={classes.toggleGroup}
      >
        <ToggleButton value="grid">
          <AppsIcon/> Orte
        </ToggleButton>
        <ToggleButton value="list">
          <ListIcon/> Lesungen
        </ToggleButton>
      </ToggleButtonGroup>
      {view == 'grid' && (

        <Grid container spacing={2}>
          {eventDataList.map((item, index) => {
            return (

                <Grid item xs={6} md={3}>
                  <Paper className={classes.gridItem}>
                  <ButtonBase className={classes.placeButton} onClick={() => { setCurrentPlace(index) }}>
                    {item.place?.images?.length > 0 &&
                    <Box>
                      <img src={item.place?.images[0].thumbnail.url}/>
                    </Box>
                    }
                    <Typography component="h3" className={classes.gridItemTitle}>{item.place?.title}</Typography>

                  </ButtonBase>
                  </Paper>
                </Grid>

            );
          })}
        </Grid>

      )}
      {view == 'list' && (
        <div className={classes.tabsroot}>
          <Tabs
            orientation={orientation}
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            className={classes.tabs}
          >
            {eventDataList.map((item, index) => {
              return (
                <Tab label={item.place?.title} {...a11yProps(index)} />
              );
            })
            }
          </Tabs>
          {eventDataList.map((item, index) => {
            return (
              <div
                role="tabpanel"
                hidden={value !== index}
                id={`vertical-tabpanel-${index}`}
                aria-labelledby={`vertical-tab-${index}`}
              >
                {value === index && (
                  <Box className={classes.tabRoot}>
                    <EventList event={item.id} closingDate={props.closingDate}></EventList>
                  </Box>
                )}
              </div>

            );
          })
          }
        </div>
      )}
    </div>
  );
}

export default EventListTabs;
